import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReactComponent as DirectionSvg } from "../assets/svg/direction.svg";
import Dropdown from "react-dropdown";
import 'react-dropdown/style.css';

interface DropdownFieldProps {
    className?: string;
    label?: string;
    required?: boolean;
    value?: string;
    initialValue?: any;
    placeholder?: string;
    isLarge?: boolean;
    isBold?: boolean;
    options?: any[];
    hasBorder?: boolean;
    disabled?: boolean;
    onChange?: (arg: any) => void;
    errorMessage?: string;
}

const propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    isLarge: PropTypes.bool,
    isBold: PropTypes.bool,
    options: PropTypes.array,
    hasBorder: PropTypes.bool
}

const defaultProps = {
    label: '',
    value: '',
    placeholder: '',
    options: [],
    isLarge: false,
    isBold: false,
    hasBorder: true,
    onChange: () => { }
}

const DropdownField = ({
    className,
    label,
    required,
    value,
    placeholder,
    isLarge,
    isBold,
    options,
    hasBorder,
    disabled,
    onChange
}: DropdownFieldProps) => {

    const classes = classNames(
        className
    );

    const controlClass = classNames(
        !hasBorder ? 'border-0' : 'dropdown-field-border',
        'dropdown-field',
        'clickable',
        isBold && (isLarge ? 'font-bold' : 'font-bold-light'),
        isLarge ? 'font-md' : (isBold ? 'font-sm' : undefined),
    )

    const trailingArrow =
        <div className='d-flex align-content-center'>
            <div className='mx-1'></div>
            <DirectionSvg />
        </div>

    const resolvedValue = React.useMemo(() => {
        const normalizedOptions = Array.isArray(options) ? options : []

        if (!value) {
            return normalizedOptions[0]
        }

        return normalizedOptions.find((option) => {
            if (typeof option === 'string') {
                return option === value
            }

            return option?.value === value || option?.label === value
        })
    }, [options, value])

    return (
        <div className={classes}>
            {label && <div className="d-flex font-xs font-bold mb-2">{label}{required && <span className="text-danger ms-1">*</span>}</div>}
            <Dropdown
                options={options ?? []}
                onChange={onChange}
                value={resolvedValue}
                placeholderClassName={'text-start'}
                menuClassName={'text-start'}
                controlClassName={controlClass}
                arrowClosed={trailingArrow}
                arrowOpen={trailingArrow}
                placeholder={placeholder}
                disabled={disabled || (options ?? []).length < 1}
            />
        </div>
    );
}

DropdownField.propTypes = propTypes;
DropdownField.defaultProps = defaultProps;

export default DropdownField;
